import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs"; 
import { useTheme } from "@mui/material";
import { useMedia } from "../context/MediaContext";
import { TProvider } from "../utils/types";
import { transactionStatuses, transactionTypes } from "../utils/utils";
import { Dayjs } from "dayjs";
import { CustomDialogHandle } from "./CustomDialog";
import { ExportFormat } from "../utils/api";
const DocumentForm: React.FC<{
  merchants: TProvider[];
  setFilters: any;
  filterss: any;
  handleChange: any;
  dialogRef: React.RefObject<CustomDialogHandle | null>;

  downloadCSV: (data: {
    type: string[];
    merchid: number[];
    status: string[];
    forMerch: boolean;
    createdFrom: Dayjs | null;
    createdTo: Dayjs | null;
    updatedFrom: Dayjs | null;
    updatedTo: Dayjs | null;
    format: ExportFormat;
  }) => Promise<void>;
}> = ({
  setFilters,
  filterss,
  handleChange,
  merchants,
  downloadCSV,
  dialogRef,
}) => {
  const [update, setUpdate] = useState<string>("");
  const [format, setFormat] = useState<ExportFormat>("csv");
  const { isMobile600 } = useMedia();
  const darkTheme = useTheme();
  const handleSubmit = (e: any) => {
    e.preventDefault();
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
      <Box
        margin="0 auto"
        width="90%"
        component="form"
        onSubmit={handleSubmit}
        paddingBottom="20px"
      >
        <Box display="flex" position="relative">
          <Button
            sx={{
              flex: 1,
              borderRadius: 0,
              color:
                darkTheme.palette.mode === "dark" && filterss.forMerch === false
                  ? darkTheme.palette.primary.light
                  : darkTheme.palette.mode === "light" &&
                    filterss.forMerch === false
                  ? `3px solid ${darkTheme.palette.primary.main}`
                  : darkTheme.palette.mode === "dark" &&
                    filterss.forMerch === true
                  ? "white"
                  : "black",

              borderBottom:
                darkTheme.palette.mode === "dark" && filterss.forMerch === false
                  ? `3px solid ${darkTheme.palette.primary.light}`
                  : darkTheme.palette.mode === "light" &&
                    filterss.forMerch === false
                  ? `3px solid ${darkTheme.palette.primary.main}`
                  : "transparent",
            }}
            onClick={() =>
              setFilters(
                (prev: {
                  search_query: string;
                  type: string[];
                  merchid: number[];
                  status: string[];
                  forMerch: boolean;
                  createdFrom: Dayjs;
                  createdTo: Dayjs | null;
                }) => ({ ...prev, forMerch: false })
              )
            }
          >
            Админ
          </Button>
          <Button
            sx={{
              flex: 1,
              borderRadius: 0,
              color:
                darkTheme.palette.mode === "dark" && filterss.forMerch === true
                  ? darkTheme.palette.primary.light
                  : darkTheme.palette.mode === "light" &&
                    filterss.forMerch === true
                  ? `3px solid ${darkTheme.palette.primary.main}`
                  : darkTheme.palette.mode === "dark" &&
                    filterss.forMerch === false
                  ? "white"
                  : "black",

              borderBottom:
                darkTheme.palette.mode === "dark" && filterss.forMerch === true
                  ? `3px solid ${darkTheme.palette.primary.light}`
                  : darkTheme.palette.mode === "light" &&
                    filterss.forMerch === true
                  ? `3px solid ${darkTheme.palette.primary.main}`
                  : "transparent",
            }}
            onClick={() =>
              setFilters(
                (prev: {
                  search_query: string;
                  type: string[];
                  merchid: number[];
                  status: string[];
                  forMerch: boolean;
                  createdFrom: Dayjs;
                  createdTo: Dayjs | null;
                }) => ({ ...prev, forMerch: true })
              )
            }
          >
            Мерчант
          </Button>
        </Box>
        <Box
          mt={3}
          position="relative"
          height="40px"
          width="100%"
          display="flex"
          gap="2%"
        >
          {["Создание", "Обновление"].map((label) => (
            <Chip
              key={label}
              sx={{
                width: "48%",
                color:
                  darkTheme.palette.mode === "dark"
                    ? "white"
                    : update === label
                    ? "white"
                    : "black",
                background:
                  update === label
                    ? "linear-gradient(90deg,#8B84FF,#635BFF)"
                    : "transparent",
              }}
              onClick={() => {
                if (label === "Обновление") {
                  setUpdate("Обновление");
                  setFilters(
                    (prev: {
                      search_query: string;
                      type: string[];
                      merchid: number[];
                      status: string[];
                      forMerch: boolean;
                      createdFrom: Dayjs | null;
                      createdTo: Dayjs | null;
                      updatedFrom: Dayjs | null;
                      updatedTo: Dayjs | null;
                    }) => ({
                      ...prev,
                      createdFrom: null,
                      updatedFrom: dayjs().startOf("day"),
                    })
                  );
                } else {
                  setUpdate("Создание");
                  setFilters(
                    (prev: {
                      search_query: string;
                      type: string[];
                      merchid: number[];
                      status: string[];
                      forMerch: boolean;
                      createdFrom: Dayjs | null;
                      createdTo: Dayjs | null;
                      updatedFrom: Dayjs | null;
                      updatedTo: Dayjs | null;
                    }) => ({
                      ...prev,
                      createdFrom: dayjs().startOf("day"),
                      updatedFrom: null,
                    })
                  );
                }
              }}
              label={label}
            />
          ))}
        </Box>

        <Box
          width={"100%"}
          display={"flex"}
          justifyContent={"center"}
          flexDirection={isMobile600 ? "column" : "row"}
          alignItems={"center"}
          gap={"10px"}
        >
          {update === "Создание" ? (
            <>
              <Box width={"100%"}>
                <InputLabel
                  shrink={true}
                  sx={{
                    fontSize: "20px",
                    marginTop: "20px",
                    transform: "translateY(-10px)",
                  }}
                >
                  Дата создания от
                </InputLabel>
                <DatePicker
                  name="createdFrom"
                  onChange={(newValue) =>
                    handleChange(
                      "createdFrom",
                      newValue ? dayjs(newValue).format("YYYY-MM-DD") : null
                    )
                  }
                  value={
                    filterss.createdFrom ? dayjs(filterss.createdFrom) : null
                  }
                  format="DD.MM.YYYY"
                  maxDate={dayjs()}
                  sx={{ width: "100%" }}
                />
              </Box>
              <Box width={"100%"}>
                <InputLabel
                  shrink={true}
                  sx={{
                    marginTop: "20px",
                    fontSize: "20px",
                    transform: "translateY(-10px)",
                  }}
                >
                  Дата создания до
                </InputLabel>
                <DatePicker
                  value={filterss.createdTo ? dayjs(filterss.createdTo) : null}
                  name="createdTo"
                  onChange={(newValue) =>
                    handleChange(
                      "createdTo",
                      newValue ? dayjs(newValue).format("YYYY-MM-DD") : null //
                    )
                  }
                  format="DD.MM.YYYY"
                  minDate={
                    filterss.createdFrom
                      ? dayjs(filterss.createdFrom)
                      : dayjs(new Date())
                  }
                  maxDate={dayjs()}
                  sx={{ width: "100%" }}
                />
              </Box>
            </>
          ) : update === "Обновление" ? (
            <>
              <Box width={"100%"}>
                <InputLabel
                  shrink={true}
                  sx={{
                    fontSize: "20px",
                    marginTop: "20px",
                    transform: "translateY(-10px)",
                  }}
                >
                  Дата обновления от
                </InputLabel>
                <DatePicker
                  name="updatedFrom"
                  onChange={(newValue) =>
                    handleChange(
                      "updatedFrom",
                      newValue ? dayjs(newValue).format("YYYY-MM-DD") : null
                    )
                  }
                  value={
                    filterss.updatedFrom ? dayjs(filterss.updatedFrom) : null
                  }
                  format="DD.MM.YYYY"
                  maxDate={dayjs()}
                  sx={{ width: "100%" }}
                />
              </Box>
              <Box width={"100%"}>
                <InputLabel
                  shrink={true}
                  sx={{
                    marginTop: "20px",
                    fontSize: "20px",
                    transform: "translateY(-10px)",
                  }}
                >
                  Дата обновления до
                </InputLabel>
                <DatePicker
                  value={filterss.updatedTo ? dayjs(filterss.updatedTo) : null}
                  name="updatedTo"
                  onChange={(newValue) =>
                    handleChange(
                      "updatedTo",
                      newValue ? dayjs(newValue).format("YYYY-MM-DD") : null //
                    )
                  }
                  format="DD.MM.YYYY"
                  minDate={
                    filterss.updatedFrom
                      ? dayjs(filterss.updatedFrom)
                      : dayjs(new Date())
                  }
                  maxDate={dayjs()}
                  sx={{ width: "100%" }}
                />
              </Box>
            </>
          ) : null}
        </Box>
        <FormControl sx={{ mt: 6, width: "100%" }}>
          <InputLabel
            shrink={true}
            sx={{
              fontSize: isMobile600 ? "18px" : "20px",
              transform: "translateY(-30px)",
            }}
          >
            Выберите тип транзакций
          </InputLabel>
          <Select
            multiple
            name="type"
            value={filterss.type}
            sx={{
              minHeight: "65px",
            }}
            onChange={(event) => handleChange(event.target.name, event)}
            renderValue={(selected) => (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                {selected.map((value: string) => (
                  <Box
                    key={value}
                    sx={{
                      px: 2,
                      py: 1,
                      borderRadius: "16px",
                      bgcolor: "primary.main",
                      color: "white",
                      fontWeight: "bold",
                      cursor: "pointer",
                      "&:hover": { opacity: 0.8 },
                    }}
                  >
                    {value}
                  </Box>
                ))}
              </Box>
            )}
          >
            {transactionTypes.map((type) => (
              <MenuItem
                sx={{
                  backgroundColor: filterss.type.includes(type)
                    ? "rgba(56, 142, 60, 0.2)"
                    : "transparent",
                  "&.Mui-selected": {
                    backgroundColor: darkTheme.palette.primary.main,
                    "&:hover": {
                      backgroundColor: darkTheme.palette.primary.main,
                    },
                  },
                }}
                value={type}
                key={type}
              >
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ mt: 6, width: "100%" }}>
          <InputLabel
            shrink={true}
            sx={{
              fontSize: isMobile600 ? "18px" : "20px",
              transform: "translateY(-30px)",
            }}
            id="demo-multiple-chip-label"
          >
            Выберите Мерчантов
          </InputLabel>
          <Select
            sx={{
              minHeight: "65px",
            }}
            multiple
            name="merchid"
            value={filterss.merchid.map(
              (merch: number) =>
                merchants.find((or: TProvider) => or.id === merch)?.name
            )}
            onChange={(event) => handleChange(event.target.name, event)}
            renderValue={(selected) => (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                {selected.map((value: string) => (
                  <Box
                    key={value}
                    sx={{
                      px: 2,
                      py: 1,
                      borderRadius: "16px",
                      bgcolor: "primary.main",
                      color: "white",
                      fontWeight: "bold",
                      cursor: "pointer",
                      "&:hover": { opacity: 0.8 },
                    }}
                  >
                    {value}
                  </Box>
                ))}
              </Box>
            )}
          >
            {merchants.map((merch) => (
              <MenuItem
                sx={{
                  backgroundColor: filterss.merchid.includes(merch.id)
                    ? "rgba(13, 190, 221, 0.2)"
                    : "transparent",
                  "&.Mui-selected": {
                    backgroundColor: darkTheme.palette.primary.main,
                    "&:hover": {
                      backgroundColor: darkTheme.palette.primary.main,
                    },
                  },
                }}
                value={merch.name}
                key={merch.id}
              >
                {merch.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ mt: 6, width: "100%" }}>
          <InputLabel
            shrink={true}
            sx={{
              fontSize: isMobile600 ? "17px" : "20px",
              transform: "translateY(-30px)",
            }}
          >
            Выберите статус транзакций
          </InputLabel>
          <Select
            sx={{
              minHeight: "65px",
            }}
            multiple
            name="status"
            value={filterss.status}
            onChange={(event) => handleChange(event.target.name, event)}
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((value: string) => (
                  <Chip
                    sx={{
                      color: "white",
                      fontSize: "20px",
                      backgroundColor:
                        value === "completed"
                          ? "rgb(56, 142, 60)"
                          : value === "canceled"
                          ? "rgb(211, 47, 47)"
                          : value === "created"
                          ? "rgb(175, 166, 41)"
                          : value === "dispute"
                          ? "rgba(99, 19, 165, 1)"
                          : null,
                    }}
                    key={value}
                    label={value}
                  />
                ))}
              </Box>
            )}
          >
            {transactionStatuses.map((status) => (
              <MenuItem
                sx={{
                  backgroundColor: filterss.status.includes(status)
                    ? "rgba(56, 142, 60, 0.2)"
                    : "transparent",
                  "&.Mui-selected": {
                    backgroundColor: darkTheme.palette.primary.main,
                    "&:hover": {
                      backgroundColor: darkTheme.palette.primary.main,
                    },
                  },
                }}
                value={status}
                key={status}
              >
                {status}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box sx={{ mt: 6 }}>
          <InputLabel
            shrink={true}
            sx={{
              fontSize: isMobile600 ? "18px" : "20px",
              transform: "translateY(-8px)",
            }}
          >
            Формат файла
          </InputLabel>
          <ToggleButtonGroup
            exclusive
            fullWidth
            value={format}
            // null приходит при повторном клике по выбранной кнопке —
            // формат должен остаться прежним, а не сброситься.
            onChange={(_event, next: ExportFormat | null) =>
              next && setFormat(next)
            }
            sx={{ mt: 1 }}
          >
            <ToggleButton value="csv">CSV</ToggleButton>
            <ToggleButton value="xlsx">XLSX</ToggleButton>
          </ToggleButtonGroup>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", mt: 1 }}
          >
            {format === "xlsx"
              ? "Книга Excel: операции разложены по листам, по одному на валюту."
              : "Один плоский список, открывается где угодно."}
          </Typography>
        </Box>
        <Button
          type="submit"
          variant="contained"
          sx={{ mt: 2 }}
          color="primary"
          onClick={() => {
            downloadCSV({
              status: filterss.status,
              createdFrom:
                filterss.createdFrom && dayjs(filterss.createdFrom).isValid()
                  ? dayjs(filterss.createdFrom).format("DD.MM.YYYY")
                  : filterss.createdFrom,
              createdTo:
                filterss.createdTo && dayjs(filterss.createdTo).isValid()
                  ? dayjs(filterss.createdTo).format("DD.MM.YYYY")
                  : filterss.createdTo,
              type: filterss.type,
              merchid: filterss.merchid,
              forMerch: filterss.forMerch,
              updatedFrom:
                filterss.updatedFrom && dayjs(filterss.updatedFrom).isValid()
                  ? dayjs(filterss.updatedFrom).format("DD.MM.YYYY")
                  : filterss.updatedFrom,
              updatedTo:
                filterss.updatedTo && dayjs(filterss.updatedTo).isValid()
                  ? dayjs(filterss.updatedTo).format("DD.MM.YYYY")
                  : filterss.updatedTo,
              format,
            });
            dialogRef?.current?.closeDialog();
            setFilters({
              search_query: "",
              type: [],
              merchid: [],
              providerid: [],
              minsum: null,
              maxsum: null,
              status: [],
              forMerch: false,
              createdFrom: null,
              createdTo: null,
              updatedFrom: null,
              currency: "",
              updatedTo: null,
              payment_method: "",
            });
          }}
        >
          Выгрузить
        </Button>
      </Box>
    </LocalizationProvider>
  );
};

export default DocumentForm;
